import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { theme } from "../../../Theme";
import {
  PROMO_ALL_BRANDS_ID,
} from "../services/promoSimulatorService";

export default function SummaryHeader({
  brands = [],
  classes = [],
  skus = [],
  brandsLoading = false,
}) {
  const {
    selectedBrand,
    selectedManufacturer,
    selectedClass,
    selectedSKUs,
    selectedWeekStart,
    selectedWeekEnd,
    discountPct,
  } = useSelector((state) => state.promoSimulator);

  const manufacturerLabel = selectedManufacturer?.trim() || "—";

  const brandLabel = brandsLoading
    ? "—"
    : !selectedBrand
      ? "—"
      : selectedBrand === PROMO_ALL_BRANDS_ID
        ? "All brands"
        : brands.find((b) => b.id === selectedBrand)?.label || selectedBrand || "—";

  const classLabel = selectedClass
    ? classes.find((c) => c.id === selectedClass)?.label || selectedClass
    : "—";

  const skuLabels =
    selectedSKUs.length > 0
      ? selectedSKUs
          .map((id) => skus.find((s) => s.id === id)?.label || id)
          .join(", ")
      : "—";

  const periodLabel =
    selectedWeekStart != null && selectedWeekEnd != null
      ? Number(selectedWeekStart) === Number(selectedWeekEnd)
        ? `Week ${selectedWeekStart}`
        : `Weeks ${selectedWeekStart}–${selectedWeekEnd}`
      : "—";

  const items = [
    { label: "Manufacturer", value: manufacturerLabel },
    { label: "Brand", value: brandLabel },
    { label: "Class", value: classLabel },
    { label: "SKUs", value: skuLabels },
    { label: "Period", value: periodLabel },
    { label: "Discount", value: `${discountPct}%` },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: 2,
        border: `1px solid ${theme.palette.primary.main}33`,
        backgroundColor: `${theme.palette.primary.main}08`,
      }}
    >
      <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
        <Typography
          variant="caption"
          fontWeight={700}
          color={theme.palette.primary.main}
          sx={{ mr: 1 }}
        >
          Active Inputs:
        </Typography>
        {items.map(({ label, value }) => (
          <Box key={label} display="flex" alignItems="center" gap={0.5}>
            <Typography variant="caption" color="text.secondary">
              {label}:
            </Typography>
            <Typography variant="caption" fontWeight={600}>
              {value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
